module.exports = __webpack_public_path__ + "static/img/47-3.7246bb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/47-3.jpg
// module id = HgQJ
// module chunks = 0